<template>
    <div class="relative-div">
        <slot></slot>
    </div>
</template>

<style scoped>
.relative-div {
    position: relative;
}
</style>
